export enum PoolExclusionCriteria {
  HUBLER_IS_NOT_IN_POOL_COUNTRY = 'HUBLER_IS_NOT_IN_POOL_COUNTRY',
  HUBLER_IS_EMPLOYEE = 'HUBLER_IS_EMPLOYEE',
  HUBLER_IS_TEMPORARY_PERSON = 'HUBLER_IS_TEMPORARY_PERSON',
  HUBLER_HAS_NOT_POOL_JOB = 'HUBLER_HAS_NOT_POOL_JOB',
  HUBLER_ADDRESS_NOT_IN_POOL_AREA = 'HUBLER_ADDRESS_NOT_IN_POOL_AREA',
}
